import { render, staticRenderFns } from "./LoginPrincipal.vue?vue&type=template&id=3292b58f&scoped=true"
import script from "./LoginPrincipal.vue?vue&type=script&lang=js"
export * from "./LoginPrincipal.vue?vue&type=script&lang=js"
import style0 from "./LoginPrincipal.vue?vue&type=style&index=0&id=3292b58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3292b58f",
  null
  
)

export default component.exports